import http from './http.service';

class PromocodeService {
    constructor() {
        if (PromocodeService.instance) {
            return PromocodeService.instance;
        }

        PromocodeService.instance = this;
    }

    promocodes() {
        return http.get('/promocode').then(res => res.data);
    }
    store(data) {
        return http.post('/promocode/store', data).then(res => res.data);
    }
    show(promocodeId) {
        return http.get(`/promocode/${promocodeId}/show`).then(res => res.data);
    }
    update(promocodeId, data) {
        return http.put(`/promocode/${promocodeId}/update`, data).then(res => res.data);
    }
    destroy(promocodeId) {
        return http.delete(`/promocode/${promocodeId}/destroy`).then(res => res.data);
    }
}

export default new PromocodeService();
